import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { FamilyService } from '@app/services/family/family.service';
import { Meta, Title } from '@angular/platform-browser';
@Component({
    selector: 'app-zone',
    templateUrl: 'zone.component.html',
    styleUrls: ['zone.component.scss'],
    providers: [FamilyService]
})
export class ZoneComponent implements OnInit {
    family = "";
    zone = "";
    postalCode = "";
    host = "";
    pdv = "";
    authorizedCities: any[] = [];
    families: any[] = [];
    constructor(
        private pdvService: PdvService,
        private route: ActivatedRoute,
        private titleService: Title,
        private familyService: FamilyService,
        private meta: Meta
    ) {

    }
    ngOnInit(): void {
        this.getFamiliesOfCarte();
        this.route.params.subscribe(params => {
            if (params['zone']) {
                let pra = params['zone'].split('-');
                let copy=JSON.parse(JSON.stringify(pra));
                this.family = pra[1];
                this.postalCode = pra[pra.length - 1];
                copy.splice(0, 2)
                copy.splice(copy.length - 1, 1)
                this.zone = copy.join('-');
                this.host = window.location.hostname;
            }
        })
        this.pdvService.getPdvInfo().subscribe(
            (pdv: any) => {
                this.pdv = pdv.name;
                this.titleService.setTitle(pdv.name+" - Livraison "+pdv.speciality+" "+ this.zone);
                this.meta.addTag({ name: 'description', content: "Votre restaurant "+pdv.name+" vous livre à domicile et au bureau vos plats préférés à " + this.zone + " et les villes aux alentours. Vous pouvez commandez en ligne facilement" });
            }
        )
        this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        );
    }

    getFamiliesOfCarte() {
        this.familyService.getFamiliesOfCarte().subscribe(
            (families: any[]) => {
                this.families = this.families = families.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (Number(a.order) > Number(b.order)) {
                            return 1;
                        }
                        if (Number(a.order) < Number(b.order)) {
                            return -1;
                        }
                        return 0;
                    }
                );
            }
        )
    }
}
